'use client'
import { PrismicRichText } from "@prismicio/react";
import { isFilled } from "@prismicio/client";
import { Splide, SplideSlide } from "@splidejs/react-splide";
import '@splidejs/react-splide/css/core';

/**
 * @typedef {import("@prismicio/client").Content.StepsHorizontalSlice} StepsHorizontalSlice
 * @typedef {import("@prismicio/react").SliceComponentProps<StepsHorizontalSlice>} StepsHorizontalProps
 * @type {import("react").FC<StepsHorizontalProps>}
 */

const Step = ({ item, idx, array }) => {
  return <div
    key={idx}
    className="flex flex-col h-full gap-6 text-dark-green w-full relative"
  >
    <div className={`${idx == array.length - 1 ? 'w-full' : 'w-[calc(100%+2.5rem)]'} h-[4px] bg-dark-green absolute top-6.5`}></div>
    <div className="bg-yellow aspect-square w-13 h-13 rounded-full relative z-50 flex justify-center items-center">
      <span className="text-number pb-1.5">{idx + 1}</span>
    </div>
    <div className="flex flex-col gap-2">
      {isFilled.richText(item.title) && (
        <PrismicRichText
          field={item.title}
          components={{
            heading3: ({ children }) => (
              <h3 className="h3-sm uppercase">{children}</h3>
            ),
            heading4: ({ children }) => (
              <h4 className="h3-sm uppercase">{children}</h4>
            ),
          }}
        />
      )}
      {isFilled.richText(item.text) && (
        <PrismicRichText
          field={item.text}
          components={{
            paragraph: ({ children }) => (
              <p>{children}</p>
            ),
          }}
        />
      )}
    </div>
  </div>
};


const StepsHorizontal = ({ slice }) => {
  const { title, text, steps } = slice.primary;
  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      className="bg-white mt-20 mb-15 md:mb-25 text-dark-green"
    >
      <div className="flex flex-col gap-8 md:gap-15">
        <div className="flex flex-col gap-4 framing">
          {isFilled.richText(title) && (
            <PrismicRichText
              field={title}
              components={{
                heading2: ({ children }) => (
                  <h2 className="h2-bold">{children}</h2>
                ),
                heading3: ({ children }) => (
                  <h3 className="h2-bold">{children}</h3>
                ),
              }}
            />
          )}
          {isFilled.richText(text) && (
            <PrismicRichText
              field={text}
              components={{
                paragraph: ({ children }) => (
                  <p>{children}</p>
                ),
              }}
            />
          )}
        </div>
        <div className="slide-steps">
          {(isFilled.group(steps) && <Splide
            options={{
              type: "slide",
              perPage: 3,
              perMove: 1,
              padding: { right: '92px', left: '92px' },
              gap: "2.5rem",
              arrows: true,
              pagination: false,
              speed: 900,
              breakpoints: {
                1024: {
                  perPage: 2,
                  padding: { right: "40px", left: "40px" },
                  gap: "2rem",
                },
                767: {
                  perPage: 1,
                  padding: { right: "25px", left: "25px" },
                  arrows: false,
                  pagination: false,
                },
              }
            }}
          >
            {steps.map((steps, idx, array) => (
              <SplideSlide key={idx}>
                <Step item={steps} idx={idx} array={array} />
              </SplideSlide>
            ))}
          </Splide>
          )
          }
        </div>
      </div>
    </section>
  );
};

export default StepsHorizontal;
